<template>
    <div class="c-entity__scoring-score flex-container" :class="classObject">
        <label
            v-if="label"
            class="c-entity__scoring-score-label flex-item-grow"
            >{{ label }}</label
        >
        <span class="c-entity__scoring-score-value flex-item-no-grow">{{
            formatted
        }}</span>
    </div>
</template>

<script>
export default {
    props: {
        value: Number,
        label: String,
        thresholdBad: Number,
        thresholdGood: Number,
    },
    data: () => {
        return {};
    },
    computed: {
        formatted() {
            return Math.round(this.value);
        },
        classObject() {
            if (!this.thresholdBad && !this.thresholdGood) {
                return;
            }
            return {
                "c-entity__scoring-score-bad": this.value < this.thresholdBad,
                "c-entity__scoring-score-good":
                    this.value >= this.thresholdGood,
            };
        },
    },
};
</script>
